import '@mdi/font/css/materialdesignicons.css'
import '@fontsource/roboto/100.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import de from 'vuetify/es5/locale/de'
import en from 'vuetify/es5/locale/en'
import el from 'vuetify/es5/locale/el'
import es from 'vuetify/es5/locale/es'
import fr from 'vuetify/es5/locale/fr'
import hr from 'vuetify/es5/locale/hr'
import id from 'vuetify/es5/locale/id'
import it from 'vuetify/es5/locale/it'
import pl from 'vuetify/es5/locale/pl'
import pt from 'vuetify/es5/locale/pt'
import ro from 'vuetify/es5/locale/ro'
import ru from 'vuetify/es5/locale/ru'
import srLatn from 'vuetify/es5/locale/sr-Latn'
import th from 'vuetify/es5/locale/th'
import tr from 'vuetify/es5/locale/tr'

// Паки Vuetify под кодами локалей приложения (src/locales/*). Непокрытые Vuetify
// локали падают на en через vuetifyLocaleFor. Наш sr — латиница → sr-Latn.
// Пак Vuetify "pt" — бразильский португальский, поэтому годится и для pt-BR.
// Подпись пагинации приводится к проектному термину custom.elements_table
// вотчером $i18n.locale в main.js — единообразно для всех языков.
const VUETIFY_LOCALES = { de, el, en, es, fr, hr, id, it, pl, pt, 'pt-BR': pt, ro, ru, sr: srLatn, th, tr }

// Код локали Vuetify для локали приложения; для неизвестных/непокрытых — en.
// Используется вотчером $i18n.locale в main.js: внутренние строки Vuetify
// (таблицы «Отсутствуют данные»/«Строк на странице», пикеры, пагинация)
// иначе навсегда остаются на языке из lang.current.
export function vuetifyLocaleFor (locale) {
  return VUETIFY_LOCALES[locale] ? locale : 'en'
}

Vue.use(Vuetify, {
  iconfont: 'md'
})

export default new Vuetify({
  theme: {
    dark: false
  },
  lang: {
    locales: VUETIFY_LOCALES,
    current: 'ru'
  }
})
